import { CatalogSearchResults } from '~/features/catalog/models/catalog-search-result';

import { createCourseListStructuredData } from './create-course-list-structured-data';

export function createCatalogStructuredData(catalogSearchResults: CatalogSearchResults) {
  const searchResultItems = catalogSearchResults?.searchResultItems ?? [];
  return {
    '@context': 'https://schema.org',
    ...createCourseListStructuredData(
      searchResultItems.map((item) => ({
        slug: item.slug,
        title: item.title,
        description: item.summary,
      }))
    ),
  };
}
